import { render, staticRenderFns } from "./StatisticsOrders.vue?vue&type=template&id=4b119d1d&scoped=true"
import script from "./StatisticsOrders.vue?vue&type=script&lang=js"
export * from "./StatisticsOrders.vue?vue&type=script&lang=js"
import style0 from "./StatisticsOrders.vue?vue&type=style&index=0&id=4b119d1d&prod&lang=css"
import style1 from "./StatisticsOrders.vue?vue&type=style&index=1&id=4b119d1d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b119d1d",
  null
  
)

export default component.exports